export default [{
  path: '/movimentacao-blindada',
  component: () => import('@/views/Index'),
  children: [
    {
      name: 'Movimentacao de Blindada Historico',
      path: 'historico',
      component: () => import('@/views/movimentacaoBlindada/Historico.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups' },
          { name: 'Movimentação da Base Homologada' }
        ]
      }
    },
    {
      name: 'Movimentacao de Blindada Adicionar',
      path: 'edit',
      component: () => import('@/views/movimentacaoBlindada/Edit.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups' },
          { name: 'Movimentação da Base Homologada', path: '/movimentacao-blindada/historico' },
          { name: 'Adicionar' }
        ]
      }
    },
    {
      name: 'Movimentacao de Blindada Editar',
      path: 'edit/:id',
      component: () => import('@/views/movimentacaoBlindada/Edit.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups' },
          { name: 'Movimentação da Base Homologada', path: '/movimentacao-blindada/historico' },
          { name: 'Editar' }
        ]
      }
    }
  ]
}]
